// app/assets/javascripts/convert_to_opv_modal.js - VERSÃO CORRIGIDA V2
import axios from "axios";
import {
  enableSelect,
  disableSelect,
} from "./attendance_concerns";

const CancelVisitModal = (() => {
  const BASE_URL = "searches";
  let currentAttendance = null;
  let attendanceMoves = [];
  let isConverting = false;

  // Seletores
  const sel = {
    modal: "#cancelVisitModal",
    situationSelect: "#situationSelectId",
    nextVisitDate: "#nextVisitDate",
    noteTextarea: "#opvNote",
    submitBtn: "#submitCancelVisit",
    cancelBtn: "#cancelCancelVisit",
  };

  // Helper para obter elemento com segurança
  const getElement = (selector) => {
    const el = document.querySelector(selector);
    if (!el) console.warn(`Elemento não encontrado: ${selector}`);
    return el;
  };

  const init = () => {
    const modal = getElement(sel.modal);
    if (!modal) {
      console.warn("Modal de conversão não encontrado no DOM");
      return;
    }

    setupEventListeners();
  };

  const setupEventListeners = () => {
    // Abrir modal ao clicar em botões com data-convert-lead
    document.addEventListener("click", (e) => {
      const btn = e.target.closest("[data-convert-lead]");
      if (btn) {
        const leadId = btn.dataset.convertLead;
        openModal(parseInt(leadId));
        e.preventDefault();
      }
    });

    // Validação ao mudar situação
    const situationSelect = getElement(sel.situationSelect);
    if (situationSelect) {
      situationSelect.addEventListener("change", updateSubmitButtonState);
    }

    // Validação ao mudar data
    const nextVisitDateInput = getElement(sel.nextVisitDate);
    if (nextVisitDateInput) {
      nextVisitDateInput.addEventListener("change", updateSubmitButtonState);
    }

    // Validação ao mudar nota
    const noteTextarea = getElement(sel.noteTextarea);
    if (noteTextarea) {
      noteTextarea.addEventListener("input", updateSubmitButtonState);
    }

    // Cancelar modal
    const cancelBtn = getElement(sel.cancelBtn);
    if (cancelBtn) {
      cancelBtn.addEventListener("click", closeModal);
    }

    // ADICIONE ISTO - Botão X de fechar:
    const closeBtn = document.querySelector(`${sel.modal} .close`);
    if (closeBtn) {
      closeBtn.addEventListener("click", closeModal);
    }

    // Submeter formulário
    const submitBtn = getElement(sel.submitBtn);
    if (submitBtn) {
      submitBtn.addEventListener("click", submitForm);
    }

    // Fechar ao clicar no backdrop
    const modal = getElement(sel.modal);
    if (modal) {
      modal.addEventListener("click", (e) => {
        if (e.target === modal) {
          closeModal();
        }
      });
    }
  };

  const populateAttendaceMovements = () => {
    const movementsEl = document.getElementById('attendanceMovements');
    if (!movementsEl || !attendanceMoves || attendanceMoves.length === 0) {
      if (movementsEl) {
        movementsEl.innerHTML = '<small class="text-muted">Nenhuma movimentação</small>';
      }
      return;
    }

    // Limitar a 5 últimas movimentações
    const movements = attendanceMoves.slice(0, 5);

    const html = movements.map(move => {
      const user = move.user ? `${move.user} - ` : '- ';
      const nextContact = move.next_contact ? `<br><small><em>Próximo contato: ${move.next_contact}</em></small>` : '';

      return `
      <div class="mb-3 pb-2 border-bottom">
        <small class="text-muted d-block">
          <strong>${move.created_at}</strong>
          <br>
          <em>${move.elapsed_time}</em>
        </small>
        <div class="mt-2">
          <strong>${user}${move.status}</strong>
          ${move.text ? `<br><small>${move.text}</small>` : ''}
          ${nextContact}
        </div>
      </div>
    `;
    }).join('');

    movementsEl.innerHTML = html;
  };

  const openModal = async (leadId) => {
    try {
      const situationSelect = getElement(sel.situationSelect);
      if (!situationSelect) return;

      showLoading(situationSelect, "Carregando situações...");

      // Buscar dados do lead
      const attendanceResponse = await axios.get(`attendances/${leadId}`);
      currentAttendance = attendanceResponse.data.attendance;
      attendanceMoves = attendanceResponse.data.moves || [];
      const situationList = attendanceResponse.data.move_statuses || [];

      if (!currentAttendance) {
        throw new Error("Atendimento não encontrado");
      }

      // Resetar formulário
      resetForm();

      if (situationList.length > 0) {
        populateSituationSelect(situationList);
        showModal();

        // Preencher informações do atendimento
        document.getElementById('attName').textContent = currentAttendance.name || '-';
        document.getElementById('attPhone').textContent = currentAttendance.phone_number || '-';
        document.getElementById('attEmail').textContent = currentAttendance.email || '-';

        populateAttendaceMovements();
      } else {
        throw new Error("Nenhuma situação encontrada para este atendimento");
      }
    } catch (error) {
      console.error("Erro ao abrir modal:", error);
      showError(`Erro ao carregar dados: ${error.message}`);
    }
  };

  const closeModal = () => {
    const modal = getElement(sel.modal);
    if (!modal) return;

    // Tentar Bootstrap 5+ primeiro
    try {
      if (window.bootstrap?.Modal) {
        const instance = bootstrap.Modal.getInstance(modal);
        if (instance) {
          instance.hide();
          return;
        }
      }
    } catch (e) {
      // Falhou com Bootstrap 5, tentar jQuery
    }

    // Bootstrap 4 com jQuery
    try {
      if (window.$ && typeof window.$.fn.modal === "function") {
        $(modal).modal("hide");
        return;
      }
    } catch (e) {
      // Falhou com jQuery
    }

    // Fallback: remover classe show
    try {
      modal.classList.remove("show");
      modal.style.display = "none";
    } catch (e) {
      console.error("Erro ao fechar modal:", e);
    }
  };

  const showModal = () => {
    const modal = getElement(sel.modal);
    if (!modal) return;

    // Bootstrap 5+
    if (window.bootstrap?.Modal) {
      const instance = new window.bootstrap.Modal(modal);
      instance.show();
    }
    // Bootstrap 4 com jQuery
    else if (window.$ && typeof window.$.fn.modal === "function") {
      $(modal).modal("show");
    }
    // Fallback: mostrar com CSS
    else {
      modal.classList.add("show");
      modal.style.display = "block";
    }
  };

  const resetForm = () => {
    const situationSelect = getElement(sel.situationSelect);
    const noteTextarea = getElement(sel.noteTextarea);

    if (situationSelect) {
      situationSelect.value = "";
      situationSelect.disabled = false;
    }

    if (noteTextarea) {
      noteTextarea.value = "";
    }

    updateSubmitButtonState();
  };

  const populateSituationSelect = (situationList) => {
    const select = getElement(sel.situationSelect);
    if (!select) return;

    // Filtrar apenas "Visita Agendada" (91) e "Visita Cancelada" (94)
    const filteredSituations = situationList.filter(status =>
      status.id === 91 || status.id === 94
    );

    const options = ['<option value="">Selecione a Situação</option>'];

    filteredSituations.forEach(status => {
      options.push(`<option value="${status.id}">${status.name}</option>`);
    });

    select.innerHTML = options.join('');
    enableSelect(select);
    refreshSelectPicker(select);
  };

  const updateSubmitButtonState = () => {
    const situationId = getElement(sel.situationSelect)?.value;
    const nextDate = getElement(sel.nextVisitDate)?.value;
    const note = getElement(sel.noteTextarea)?.value;
    const submitBtn = getElement(sel.submitBtn);

    if (!submitBtn) return;

    const isValid = situationId && nextDate && note && note.trim().length > 0;
    submitBtn.disabled = !isValid;

    if (isValid) {
      submitBtn.textContent = "✓ Cadastrar Providência";
      submitBtn.className = "btn btn-success";
    } else {
      submitBtn.textContent = "Cadastrar Providência";
      submitBtn.className = "btn btn-light";
    }
  };

  const showLoading = (selectElement, message) => {
    if (!selectElement) return;
    selectElement.innerHTML = `<option value="">${message}</option>`;
    selectElement.disabled = true;
  };

  const refreshSelectPicker = (selectEl) => {
    if (!selectEl) return;

    try {
      // Primeiro, tentar jQuery directamente
      if (window.$ && $(selectEl).data('selectpicker')) {
        $(selectEl).selectpicker('refresh');
        return;
      }
    } catch (error) {
      console.warn('Erro ao atualizar selectpicker com jQuery:', error);
    }

    try {
      // Usa a forma específica de acessar o selectpicker
      let [refEl] = Object.values(selectEl).filter(a => a?.liveSearch && a);
      if (refEl && refEl.selectpicker) {
        // Usa setTimeout para evitar conflitos de renderização
        setTimeout(() => {
          refEl.selectpicker.refresh();
        }, 0);
      }
    } catch (error) {
      console.warn('Erro ao atualizar selectpicker:', error);
    }
  };

  const submitForm = async () => {
    if (isConverting) return;

    const situationId = getElement(sel.situationSelect)?.value;
    const nextDate = getElement(sel.nextVisitDate)?.value;
    const note = getElement(sel.noteTextarea)?.value || "";

    if (!situationId || !nextDate || !note) {
      showError("Preencha todos os campos obrigatórios");
      return;
    }

    if (!currentAttendance) {
      showError("Erro: Atendimento não foi carregado");
      return;
    }

    isConverting = true;
    const submitBtn = getElement(sel.submitBtn);
    const originalText = submitBtn.textContent;

    submitBtn.disabled = true;
    submitBtn.innerHTML =
      '<span class="spinner-border spinner-border-sm mr-2"></span>Cadastrando...';

    try {
      // POST direto para criar o move
      await axios.post(`attendances/${currentAttendance.id}/create_move`, {
        move: {
          moveable_type: "Attendance",
          status_id: parseInt(situationId),
          category_id: null,
          kind: "activity",
          text: note,
          next_contact: nextDate
        }
      });

      // Sucesso
      showSuccess("Providência cadastrada com sucesso!");
      closeModal();

      // Recarregar página após 1.5 segundos
      setTimeout(() => {
        window.location.reload();
      }, 1500);

    } catch (error) {
      console.error("Erro ao cadastrar:", error);

      const errorMsg =
        error.response?.data?.error ||
        error.response?.data?.message ||
        error.message ||
        "Erro desconhecido ao cadastrar";

      showError(`Erro: ${errorMsg}`);

      submitBtn.disabled = false;
      submitBtn.textContent = originalText;
      isConverting = false;
    }
  };

  // REMOVIDO: função prepareAttendanceData não é mais necessária

  const showError = (message) => {
    if (typeof Swal !== "undefined") {
      Swal.fire({
        icon: "error",
        title: "Erro",
        text: message,
        showCloseButton: true,
        confirmButtonText: "OK",
      });
    } else {
      alert(`❌ Erro: ${message}`);
    }
  };

  const showSuccess = (message) => {
    if (typeof Swal !== "undefined") {
      Swal.fire({
        icon: "success",
        title: "Sucesso",
        text: message,
        showCloseButton: true,
        timer: 2000,
        timerProgressBar: true,
        confirmButtonText: "OK",
      });
    } else {
      alert(`✅ ${message}`);
    }
  };

  return {
    init,
  };
})();

// Inicializar quando o DOM estiver pronto
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    CancelVisitModal.init();
  });
} else {
  CancelVisitModal.init();
}

export default CancelVisitModal;